module.exports = [
    'common',
    'applicationStateService',
    'dataContext', 
    scheduleBDataService
];
function scheduleBDataService(
    common,
    state,
    dataContext
) {
    var service = {
        getScheduleBPdfFile: getScheduleBPdfFile
    };
    return service;

    function getScheduleBPdfFile(fileTitle) {
        var url = common.config.apiHosts.generic + '/schedule-b/pdf/' + fileTitle + '?date=' + state.filter.date;
        return dataContext.getPdfAsObjectUrl(url);
    }
}